import emitter from '../../mixin/emitter'

export default {
  name: 'UiFormFileInput',

  mixins: [emitter],

  inheritAttrs: false,

  inject: {
    uiFormItem: {
      default: '',
    },
  },

  // language=HTML (for PhpStorm)
  template: `
    <div
      :class="[
        'ui-input',
        {
          'is-disabled': disabled,
        }
      ]"
    >
      <input
        ref="input"
        type="file"
        class="ui-input__inner"
        :class="inputClass"
        :style="inputStyle"
        v-bind="$attrs"
        :id="computedId"
        :disabled="disabled"
        @input="handleInput"
        @change="handleChange"
        @blur="handleBlur"
      />
    </div>
  `,

  props: {
    type: {
      type: String,
      default: 'text',
    },

    id: String,
    disabled: Boolean,
    value: FileList,
    inputClass: {
      type: [Array, Object, String],
      default() {
        return []
      },
    },
    inputStyle: {
      type: [Array, Object],
      default() {
        return {}
      },
    },
  },

  data() {
    return {
      currentValue: this.value === undefined || this.value === null ? '' : this.value,
    }
  },

  computed: {
    computedId() {
      if (this.id) {
        return this.id
      }

      return this.uiFormItem.computedId
    },
  },

  methods: {
    handleInput(ev) {
      this.setCurrentValue(ev.target.value)
      this.$emit('input', ev.target.files)
    },

    handleChange(ev) {
      this.$emit('change', ev.target.files)
    },

    handleBlur(ev) {
      this.$emit('blur', ev)
      this.dispatch('UiFormItem', 'ui.form.blur', [this.currentValue])
    },

    setCurrentValue(value) {
      this.currentValue = value
    },
  },
}
